import {characteristicMultiple} from "@/helper/application/Populate";

export function characteristicsValue(value, meta, characteristicItemsMetaProperty, characteristicTypeMetaProperty)
{
	if (value === undefined)
	{
		return value;
	}

	return characteristicMultiple(
		value,
		meta,
		meta[characteristicItemsMetaProperty],
		meta[characteristicTypeMetaProperty],
		true
	);
}
